<template>
  <div class="app">
    <div class="registerBox">
      <div class="rightBox">
        <div class="Tips" style="margin-bottom: 4px">必填信息</div>
        <div class="Requirement" style="border-top: 1px solid #e0e0e0">
          <div class="letRe fl">卡号</div>
          <input
            class="rigRe fr"
            type="number"
            placeholder="请输入卡号"
            pattern="[0-9]*"
            v-model="vipno"
            @focus="focus"
            @blur="blur"
          />
        </div>
        <div class="Requirement">
          <div class="letRe fl">姓名</div>
          <input
            class="rigRe fr"
            type="text"
            placeholder="请输入姓名"
            v-model="name"
            @focus="focus"
            @blur="blur"
          />
        </div>
        <div class="Requirement">
          <div class="letRe fl">电话</div>
          <input
            class="rigRe fr"
            type="number"
            placeholder="请输入电话号码"
            pattern="[0-9]*"
            v-model="tel"
            @focus="focus"
            @blur="blur"
          />
          <div
            class="vcodeSty"
            @click="clickVcode"
            :class="itemFlase ? '' : 'vcodeStyFa'"
          >
            {{ itemFlase ? '获取验证码' : idx }}
          </div>
        </div>
        <div class="Requirement">
          <div class="letRe fl">验证码</div>
          <input
            class="rigRe fr"
            type="number"
            placeholder="请输入验证码"
            pattern="\d*"
            v-model="vcode"
            @focus="focus"
            @blur="blur"
            @input="handleChange($event)"
          />
        </div>
        <div class="Tips">
          <div class="Tips_lo fl">i</div>
          <div class="Tips_text fl">
            卡号、姓名、电话要与办卡时一致才能通过验证
          </div>
        </div>
        <div class="Determine" @click="clickApply()">申请绑定</div>
      </div>
    </div>
    <loading v-if="load"></loading>
    <div class="toast" v-show="toast">{{ toastText }}</div>
  </div>
</template>

<script>
export default {
  name: 'BindingMember',
  data() {
    return {
      appcode: '',
      code: '',
      vipno: '',
      name: '',
      tel: '',
      toast: false,
      toastText: '',
      timer: '',
      load: false,
      vcode: '',
      itemFlase: true,
      idx: 60,
    }
  },

  mounted() {
    this.appcode = localStorage.getItem('appcode')
    this.code = localStorage.getItem('code')
  },
  methods: {
    clickApply() {
      console.log('申请绑定', this.code)
      this.load = true
      this.RequestVIP2(
        '/h5/vip/bind',
        {
          cardNo: this.vipno,
          name: this.name,
          tel: this.tel,
          openID: this.code.replace(/(^\s*)|(\s*$)/g, ''),
          smsCode: this.vcode,
        },
        (r) => {
          console.log(r, 'rrrrrrrrrrrrrr')
          this.toastText = r.data.msg
          // == 'ok' ? 4 : 3
          this.load = false
          this.toast = true
          let timer = setTimeout(() => {
            if (r.data.code == '20000') {
              this.$router.push({
                path: '/BindingMenmberCard',
              })
            }
            this.toast = false
            clearTimeout(timer)
          }, 1000)
        },
        (err) => {
          alert(err)
        }
      )
    },
    clickVcode() {
      if (this.itemFlase) {
        this.itemFlase = false
        this.idx = 60
        let timer = setInterval(() => {
          this.idx -= 1
          if (this.idx == 0) {
            this.itemFlase = true
            clearInterval(timer)
          }
        }, 1000)
        var reg_tel =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        if (!!reg_tel.test(this.tel)) {
          this.RequestVIP(`/h5/vip/sms?tel=${this.tel}`, (r) => {
            if (r.data.code === '20000') {
              this.toast = true
              this.toastText = '验证码已发送'
              setTimeout(() => {
                this.toast = false
              }, 1000)
            } else {
              this.itemFlase = true
              clearInterval(timer)
              this.toastText = r.data.msg
              this.toast = true
              let timera = setTimeout(() => {
                this.toast = false
                clearTimeout(timera)
              }, 1000)
            }
          })
        } else {
          this.itemFlase = true
          clearInterval(timer)
          this.toastText = '请填写正确的手机号'
          this.toast = true
          let timera = setTimeout(() => {
            this.toast = false
            clearTimeout(timera)
          }, 1000)
        }
      }
    },
    focus() {
      this.focusFalse = true
      clearTimeout(this.timer)
    },
    blur() {
      this.focusFalse = false
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0)
        // 间隔设为10，减少页面失去焦点定时器的突兀感，
      }, 10)
    },
    handleChange(event) {
      if (event.target.value > 6) {
        this.vcode = event.target.value.slice(0, 6)
      }
    },
  },
  destroyed() {
    this.timer = setTimeout(() => {
      window.scrollTo(0, 0)
      // 间隔设为10，减少页面失去焦点定时器的突兀感，
      clearTimeout(this.timer)
    }, 10)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app {
  height: 100%;
  width: 100%;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.registerBox {
  width: 94%;
  margin-left: 3%;
  background: #fff;
  border-radius: 5px;
  height: 74%;
  margin-top: 10px;
  box-shadow: 0px 0px 5px 0px #bdbdbd;
  position: relative;
}

.rightBox {
  float: right;
  width: 94%;
  height: 100%;
  margin-top: 10px;
}

.rightBox > div {
  border-bottom: 1px solid #e0e0e0;
}

.Tips {
  font-size: 12px;
  color: #757575;
  height: 20px;
  line-height: 20px;
}

.Requirement {
  height: 35px;
  line-height: 35px;
  font-size: 11px;
  color: #212121;
  position: relative;
}

.letRe {
  width: 22%;
  height: 100%;
}

.rigRe {
  display: block;
  height: 100%;
  width: 75%;
  border: none;
  border-bottom: 1px solid #e0e0e0;
  font-size: 11px;
}

input::-webkit-input-placeholder {
  color: #bdbdbd;
  font-size: 11px;
}

input {
  outline: none;
}

.Tips {
  width: 100%;
  height: 20px;
  margin-top: 10px;
  border: none !important;
  font-size: 8px;
}

.Tips_lo {
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  margin-top: 4px;
  margin-right: 3%;
  font-size: 8px;
}

.Tips_text {
  color: #757575;
  line-height: 20px;
}

.Determine {
  width: 93%;
  height: 32px;
  text-align: center;
  line-height: 32px;
  color: #fff;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  border-radius: 4px;
  font-size: 11px;
  text-decoration: none;
  margin-top: 38%;
}

.vcodeSty {
  height: 19px;
  line-height: 19px;
  position: absolute;
  right: 6px;
  top: 6px;
  width: 46px;
  border: 0.5px solid red;
  color: red;
  font-size: 8px;
  border-radius: 2px;
  text-align: center;
}

.vcodeStyFa {
  border: 0.5px solid #bdbdbd;
  color: #bdbdbd;
}

.toast {
  width: 100px;
  line-height: 15px;
  padding: 10px;
  border-radius: 5px;
  background: rgb(49, 47, 47);
  opacity: 0.5;
  color: white;
  position: fixed;
  top: 46%;
  left: 30%;
  text-align: center;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/BindingMember/index.vue